import React from "react";

import { usePatientStore } from "~/stores";
import {
  FollowUpVisitFormData,
  followUpVisitSchema,
} from "../validation/schema";
import { VisitForm } from "./VisitForm";

type FollowUpVisitFormProps = {
  onSubmit: (data: FollowUpVisitFormData) => void;
  isLoading?: boolean;
};

export const FollowUpVisitForm = ({
  onSubmit,
  isLoading = false,
}: FollowUpVisitFormProps) => {
  const insuranceData = usePatientStore((state) => state.insuranceData);
  return (
    <VisitForm
      schema={followUpVisitSchema}
      onSubmit={onSubmit}
      isLoading={isLoading}
      fillInsuranceLater={!insuranceData}
    >
      <VisitForm.OptionalAddress switchVariant="secondary" />
      {insuranceData && (
        <VisitForm.OptionalInsurance switchVariant="secondary" />
      )}
      <VisitForm.Consents />
      <VisitForm.CancellationPolicy />
      <VisitForm.SubmitSection />
    </VisitForm>
  );
};
